import React, { Component } from 'react';
import { Row, Col } from 'antd';
import {
  Route, Switch, Redirect, withRouter,
} from 'react-router-dom';
import { connect } from 'react-redux';
import SideMenu from '../../components/SideMenu/SideMenu';
import Orders from './Orders/Orders';
import Profile from './Profile/Profile';
import CurrentOrders from './CurrentOrders/CurrentOrders';
// import PropTypes from 'prop-types';

export class Driver extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      menuKey: '',
    };
  }

  async componentDidMount() {
    await this.setState({
      menuKey: window.location.pathname.toString().replace('/driver/', ''),
    });
  }

  render() {
    const menuLinks = [
      {
        key: 'current',
        href: '/driver/current',
        name: 'Current',
        intlName: 'currentOrders',
      },
      {
        key: 'orders',
        href: '/driver/orders',
        name: 'Orders',
        intlName: 'orders',
      },
      {
        key: 'profile',
        href: '/driver/profile',
        name: 'Profile',
        intlName: 'profile',
      },
    ];

    return (
      <div style={{ padding: '10px 20px' }}>
        <h1>Driver</h1>
        <Row gutter={24}>
          {this.state.menuKey !== '' ? (
            <SideMenu menuLinks={menuLinks} menuKey={this.state.menuKey} />
          ) : null}
          <Col md={18} xs={24}>
            <Switch>
              <Route exact path="/driver/current" component={CurrentOrders} />
              <Route exact path="/driver/orders" component={Orders} />
              <Route exact path="/driver/profile" component={Profile} />
              <Redirect from="/driver" to="/driver/orders" />
            </Switch>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(Driver));
